"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagsAutoclose = exports.tagsWithNoBody = exports.tagsWithValue = exports.allTags = exports.Tag = void 0;
var Tag;
(function (Tag) {
    Tag["Align"] = "align";
    Tag["Alpha"] = "alpha";
    Tag["Color"] = "color";
    Tag["Bold"] = "b";
    Tag["Italic"] = "i";
    Tag["CSpace"] = "cspace";
    Tag["Font"] = "font";
    Tag["Indent"] = "indent";
    Tag["LineHeight"] = "line-height";
    Tag["LineIndent"] = "line-indent";
    Tag["Link"] = "link";
    Tag["Lowercase"] = "lowercase";
    Tag["Uppercase"] = "uppercase";
    Tag["Smallcaps"] = "smallcaps";
    Tag["Margin"] = "margin";
    Tag["Mark"] = "mark";
    Tag["MSpace"] = "mspace";
    Tag["NoParse"] = "noparse";
    Tag["NoBR"] = "nobr";
    Tag["Page"] = "page";
    Tag["Pos"] = "pos";
    Tag["Size"] = "size";
    Tag["Space"] = "space";
    Tag["Sprite"] = "sprite";
    Tag["Strikethrough"] = "s";
    Tag["Underline"] = "u";
    Tag["Style"] = "style";
    Tag["Sub"] = "sub";
    Tag["Sup"] = "sup";
    Tag["VOffset"] = "voffset";
    Tag["Width"] = "width";
})(Tag = exports.Tag || (exports.Tag = {}));
exports.allTags = [
    Tag.Align,
    Tag.Alpha,
    Tag.Color,
    Tag.Bold,
    Tag.Italic,
    Tag.CSpace,
    Tag.Font,
    Tag.Indent,
    Tag.LineHeight,
    Tag.LineIndent,
    Tag.Link,
    Tag.Lowercase,
    Tag.Uppercase,
    Tag.Smallcaps,
    Tag.Margin,
    Tag.Mark,
    Tag.MSpace,
    Tag.NoParse,
    Tag.NoBR,
    Tag.Page,
    Tag.Pos,
    Tag.Size,
    Tag.Space,
    Tag.Sprite,
    Tag.Strikethrough,
    Tag.Underline,
    Tag.Style,
    Tag.Sub,
    Tag.Sup,
    Tag.VOffset,
    Tag.Width
];
exports.tagsWithValue = [
    Tag.Align,
    Tag.Alpha,
    Tag.Color,
    Tag.CSpace,
    Tag.Font,
    Tag.Indent,
    Tag.LineHeight,
    Tag.LineIndent,
    Tag.Link,
    Tag.Margin,
    Tag.Mark,
    Tag.MSpace,
    Tag.Pos,
    Tag.Size,
    Tag.Space,
    Tag.Sprite,
    Tag.Style,
    Tag.VOffset,
    Tag.Width
];
exports.tagsWithNoBody = [Tag.Sprite, Tag.Pos];
exports.tagsAutoclose = [
    Tag.VOffset,
    Tag.Size,
    Tag.CSpace,
    Tag.Align,
    Tag.Width,
    Tag.Font
];
//# sourceMappingURL=types.js.map